(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4799],{

/***/ 64358:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Example; }
});

// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./src/views/Marketing/Blog/components/BlogPage/index.tsx
var BlogPage = __webpack_require__(32526);
// EXTERNAL MODULE: ./src/views/Marketing/components/Footer/index.tsx
var Footer = __webpack_require__(45867);
// EXTERNAL MODULE: ./src/views/Marketing/components/NavBar/index.tsx
var NavBar = __webpack_require__(82969);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/cjs/exports/ScrollView/index.js
var ScrollView = __webpack_require__(38174);
var ScrollView_default = /*#__PURE__*/__webpack_require__.n(ScrollView);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/cjs/exports/StyleSheet/index.js
var StyleSheet = __webpack_require__(84099);
var StyleSheet_default = /*#__PURE__*/__webpack_require__.n(StyleSheet);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/views/Marketing/Blog/marketing/depop-verified-badge/index.tsx







function Page() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)((ScrollView_default()), {
    style: styles.scrollView,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(NavBar/* default */.Z, {}), /*#__PURE__*/(0,jsx_runtime.jsxs)(BlogPage/* default */.Z, {
      author: "OneShop Team",
      dateTime: "2022-06-12",
      tag: "Depop",
      title: "Depop Badge: How To Get Verified By Becoming a Top Seller on the App",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Be it a newbie or a veteran seller on e-commerce sites, gaining the trust of buyers is your stepping stone to closing sales. Without credibility, you would find it tough to even attract attention to your listings and receive inquiries."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "On social media platforms like Facebook and Instagram, accounts with a blue tick beside their names are usually given to personalities, figures of authority, brands, and media, which signifies that these accounts are verified by the platform and are authentic and trustworthy."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Similarly, the blue tick on Depop acts as a badge given to brands, celebrities, and top sellers. The latter category is where aspiring superior sellers would want to belong. When you have this badge, it increases your chances of receiving inquiries and closing sales. But what else can you get from this verification? How do you earn it and maintain it?"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: "Depop Verified Badge"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "For those unfamiliar, you may have encountered a blue checkmark or a blue badge beside a Depop user\u2019s account. This means the platform has verified it to be authentic or legit. If it belongs to a Top Seller, it means they are closing sales at a high volume. Buyers trust them, and some may be loyal customers who repeat orders from this seller."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Who gets this badge? Typically, brands, celebrities, and Top Sellers earn this blue tick. For the first two categories, verification of their accounts is crucial. They are \u201Cauthorities\u201D or public figures, and so people must be aware of whether or not the accounts they follow or transact with are the \u201Creal\u201D brands and personalities."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "The online landscape is notorious for scams and numerous fake accounts. They serve the purpose of defrauding unassuming people, mostly for money. Other times, for social media fame. Whatever the reason is, bogus accounts are dangerous to encounter."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "This is why online marketplaces like Depop have made efforts to review accounts of big names and brands. This may take time, but it is always better to confirm their identities. This helps avoid the possibility of scam transactions and protects customers from such experiences."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: "Why be a trusted seller?"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "If you are outside the categories of brands and personalities, you can still earn the Depop badge. It is by becoming a Top Seller on the platform. This title is given to those sellers who are performing well, making buyers happy with attractive listings and great customer service. They receive an invite-only program with special benefits as rewards for their efforts."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "You may be wondering, why is it so necessary to be a Top Seller? Beyond the benefits, your priority should be becoming a credible seller. Trusted sellers are more likely to entice potential buyers as they have demonstrated effective communication with potential clients. This includes being transparent about the condition of the items, being clear and direct with any inquiry a customer may have, and properly shipping the orders."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "When you perform well as a seller, and your buyer is happy and satisfied with the customer service, then they will give you a high rating. The more positive feedback you receive, the more other Depop users will flock to you."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Your past transactions matter a lot to customers. These help them evaluate whether or not to push through with purchasing your items. If they see that you have been doing great, then you earn their trust that you won\u2019t scam them. Again, the latter is widespread in online spaces. So, if you can prove that you are legit, you are already stepping ahead to closing more sales."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: "Getting the Badge"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Depop does not give the blue checkmark to accounts. For brands and personalities, they reach out to the platform\u2019s Support team. But if you are an ordinary user, you have to become a Top Seller first."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Generally, when you maintain a great presence on the e-commerce site/app, you can become a Top Seller. Here are the rest of the criteria to be considered as such:"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Either sold $2,600 worth of items for four months in a row or sold 50+ items at an average of $20 for four consecutive months."
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Ship items within three days, so the buyer receives the parcel in 10 days."
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Earn an average rating of 4.5 stars"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "No previous violation of Depop's Community Guidelines"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: "Tips for Becoming a Top Seller"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Achieving the title is no easy feat, especially when reselling is not a full-time role for you. Below are some effective ways to help you."
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h4", {
            children: "Source quality items"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
            children: "Any buyer prefers to purchase only items or products that are quality. This means they are getting what they are willing to pay for. But where do you get these pieces? Typical sourcing destinations include thrift stores, consignment, department stores, and garage and yard sales. You only need to be patient and keep an eye out for what can attract people and sell well. Research trends and styles that people want now."
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h4", {
            children: "Create attractive listings"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
            children: "Listings make or break a sale. When you have good photos and a clear description of the items, then you are already on your way to enticing potential customers."
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
            children: "For photos, you need not have a professional camera. A smartphone, a plain background, and natural lighting are the key elements you need. Capture the overall look of the item and do close-ups of the details. Buyers want to see the condition of the item before purchasing it."
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
            children: "For descriptions, make sure you are direct and honest. More people will view you as a credible seller when you have clear labels, including the brand, size, color, type, material, and similar. Clients want to have as much information as possible before they buy the item."
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
            children: "When it comes to the price, always research first, nothing turns off a potential buyer than seeing an overpriced item (when another Depop seller tagged the same item lower) or an overly cheap item. Either you are asking too much or asking too little that it seems a bit suspicious. The best way is to search for similar items from other marketplaces to help you gauge your price."
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h4", {
            children: "Respond quickly to inquiries"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
            children: "When buyers visit the website or the app, they are most likely to check out right away once they find the item they want. That is why when they message you a question about your listing, respond right away\u2013as much as your time allows you to. Buyers want to receive answers in the shortest time possible, so they know if they will check out or move on to another listing."
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
            children: "In responding, make sure you are honest, straightforward, and polite. Transparency about the condition of the item matters, and so even if there are minor flaws like a tiny scratch or rip, let the potential client know. There is no need to be afraid as people appreciate this kind of honesty rather than keeping that crucial information only to discover once they receive the order. This case is difficult to handle as the buyer can report you as a scam."
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h4", {
            children: "Use an automated tool."
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
            children: "Some sellers may be wary of using third-party apps or tools in their business. But once they do try and experience usage, they make these tools their virtual business partner."
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
            children: "A great example is OneShop, a service app that allows you to cross-promote and delist your listings on Depop, eBay, Poshmark, Tradesy, and Mercari. When you cross-list, you widen your exposure to thousands of other users on e-commerce sites and apps. The more visible you are to people, the more likely you will catch their interest and transact with you."
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
            children: "On Depop, \u201Cauto bumping\u201D will be available soon. This feature helps in boosting your listings. While you can manually \u201Cbump\u201D to reach more users, this can be time-consuming. This is why OneShop is your assistant to execute this task\u2013all with minimal effort from your end."
          })]
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: "Growing Your Business"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Reaching the status of a Top Seller and earning that blue badge beside your name is indeed challenging. It takes time and effort to close sales to reach your monthly targets. Thankfully, OneShop is not limited to automation. The app can also help you monitor your performance to see which aspects you need to improve on."
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["OneShop has a ", /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
          href: "https://tools.oneshop.com/signup",
          children: "free trial"
        }), " for seven days. Sign up for this and get to know how selling is so much easier with a virtual business assistant."]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Footer/* default */.Z, {})]
  });
}
var styles = StyleSheet_default().create({
  scrollView: {
    flex: 1
  }
});
;// CONCATENATED MODULE: ./src/pages/blog/depop-verified-badge.tsx





function Example() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)((head_default()), {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("title", {
        children: "Depop Badge: How To Get Verified By Becoming a Top Seller on the App"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        name: "description",
        content: "Similar to other social media sites, getting that blue tick beside your username feels like a badge\u2013and indeed it is\u2013for sellers, celebrities, and figures on Depop. But what exactly does this mean?"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
        rel: "canonical",
        href: "https://tools.oneshop.com/blog/depop-verified-badge"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:url",
        content: "https://tools.oneshop.com/blog/depop-verified-badge"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:title",
        content: "Depop Badge: How To Get Verified By Becoming a Top Seller on the App"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:description",
        content: "Similar to other social media sites, getting that blue tick beside your username feels like a badge\u2013and indeed it is\u2013for sellers, celebrities, and figures on Depop. But what exactly does this mean?"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:image",
        content: "https://tools.oneshop.com/static/images/og-image.png?v=3"
      }, 'og-image'), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "article:published_time",
        content: "2022-06-12T00:00:00-00:00"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "article:modified_time",
        content: "2022-06-12T00:00:00-00:00"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "article:tag",
        content: "Depop"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "article:publisher",
        content: "https://www.facebook.com/oneshopcompany"
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Page, {})]
  });
}

/***/ }),

/***/ 41224:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/depop-verified-badge",
      function () {
        return __webpack_require__(64358);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2678,4885,8409,8908,8776,8174,6770,1664,4965,9561,5675,1577,6554,858,275,9774,2888,179], function() { return __webpack_exec__(41224); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);